module.exports = __webpack_public_path__ + "img/mineBGImg.dc95ac40.png";